// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import { MessageEventKind } from "../../../define/MessageEventKind";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class BoastGuiFeiHint extends BasePopUpLayer {

	@property({ type: cc.Label, displayName:'' })
	labelHint2: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelHint1: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	btnConfirmVideo: cc.Node = null;


    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.initLayer();
    }

    initLayer() {
       this.refreshState();
    }

    refreshState() {
        let gameData = NormalGameManager._instance.getGameData();
        if (gameData.boastGuiFeiAdCount == 0) {
            this.btnConfirmVideo.active = true;
            this.labelHint2.node.active = false;
            this.labelHint1.node.active = true;
        } else {
            this.btnConfirmVideo.active = false;
            this.labelHint2.node.active = true;
            this.labelHint1.node.active = false;
        }
    }

    onClickAd() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        utilsModel.loadAndShowVideoAdTrans(()=>{
            let gameData = NormalGameManager._instance.getGameData();
            gameData.boastGuiFeiAdCount++;
            NormalGameManager._instance.writeGameData();
            this.refreshState();
            O1HD.emit(MessageEventKind.EventName.BOAST_GUI_FEI_HINT);
        },()=>{
 
        }, null, "夸贵妃看广告获得提示");
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
    }

    // update (dt) {}
}
